export default function () {
  if (this.user.image_required === 'true') {
    if (this.user.image_id === null) {
      this.$toast.error('Você precisa definir uma foto no seu perfil.')
      return this.$router.push({name: 'dweller.profile.me.me'})
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/tenant/common-area/resources/mounted.js